module.exports = __webpack_public_path__ + "media/images/restaurant/areas/central_honshu-2bb7fb353ab6914ac74865d8e5db258d.png";